import { Navigate } from 'react-router-dom';
import { getUser } from '../services/authService';
import { RegionService } from '../services/regionService';
import { AppRoutes } from '../constants/appRoutes';

export const CheckLogin = ({ children }) => {
	const user = getUser();
	const regionService = new RegionService();
	if (!user?.isApproved || !user?.OtpVerified) {
		return (
			<Navigate
				to={`/${regionService.currentRegion()}/${AppRoutes.Login}`}></Navigate>
		);
	}

	return children;
};

export const AlreadyLogin = ({ children }) => {
	const user = getUser();
	if (user?.isApproved && user?.OtpVerified) {
		return <Navigate to="/"></Navigate>;
	}

	return children;
};
